import React, { useState, useCallback, useEffect} from "react";
import { LazyLoadImage } from 'react-lazy-load-image-component';

const TOTAL_FRAMES =992;

const lock = (num, min, max) => {
  return num <= min ? min : num >= max ? max : num;
};

const scale = (number, inMin, inMax, outMin, outMax) => {
  return ((number - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
};

const total_slides=39

const getPerFrameNumFromScroll = (per, settings) => {
  let currentFramePad = "000";
  const slideNum = Math.floor(per);
  const slideNumprop = Math.floor(per*total_slides/100);
  const perProp = per*total_slides/100


  const percentage = perProp - slideNumprop;

  const scrollKeyEdited = slideNumprop; 

  const scrollKey = scrollKeyEdited.toString();
  //console.log(scrollKey, Object.keys(settings).includes(scrollKey));
  if (Object.keys(settings).includes(scrollKey)) {
    const startFrame = settings[scrollKey][0];
    const endFrame = settings[scrollKey][1];

    const animate_start = 0.1;
    const animate_end = 0.9;
    const percentage_lock = lock(percentage, animate_start, animate_end);
    //console.log ("perlock",percentage_lock)
    const currentFrame = scale(
      percentage_lock,
      animate_start,
      animate_end,
      startFrame,
      endFrame
    );
    const currentFrameFloor = Math.floor(currentFrame);
    const currentFrameString = currentFrameFloor.toString();
    currentFramePad = currentFrameString.padStart(3, "0");
    //console.log(currentFramePad);
  }

  return currentFramePad;
};

export default function ScrollVideo(props) {

  const settings = props.videoSettings;
  const wrapperDiv = props.divRef.current;
  const currentSlide = props.currentSlide;
  const TOTAL_FRAMES = props.isMobile? 992 : 927
  const width = props.innerWidth
  const height = window.innerHeight

  const [frame, setFrame] = useState(0);

  const handleScroll = useCallback(
    (div, settings, chapterStartSlide, index) => () => {
      // console.log("from SCROLL: handle scroll is running.... ");
      const position =
        div.scrollTop + chapterStartSlide * window.innerHeight * 1.2;
      const heigt = Math.max(
          div.scrollHeight
        );
      const scrollPercentage = position / (heigt - window.innerHeight)*100
      const currentFrame = getPerFrameNumFromScroll(scrollPercentage, settings);
      setFrame(currentFrame);
    },
    []
  );

  useEffect(() => {
    //console.log("adding an event listener");
    wrapperDiv.addEventListener(
      "scroll",
      handleScroll(wrapperDiv, settings, props.chapterStartSlide, props.currentSlide.index),
      {
        passive: true,
      }
    );
    // cleanup this component
    return () => {
      window.removeEventListener(
        "scroll",
        handleScroll(wrapperDiv, settings, props.chapterStartSlide, props.currentSlide.index)
      );
    };
  }, [handleScroll, wrapperDiv, settings, props.chapterStartSlide, props.currentSlide.index]);

  return (
    props.isMobile? 
    <div
    id={"scrollable-video"}
    style={{
      // color: "black",
      position: "fixed",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "black",
      //opacity: currentSlide.scrollVideo ? "1" : "1",
      pointerEvents: "none",
      zIndex: currentSlide.scrollVideo,
      width: "100vw",
      height: "100vh",
      // padding: 10,
    }}
  >
    <img
        width="100%"
        preload={"true"}
        loading={"lazy"}
        src={
          `FramesMobile/AlSina_MobFrame${frame}.jpg`
        }
        alt=""
      ></img>
    </div>
    :
    <div
    id={"frame-scroll"}
    style={{
      // color: "black",
      position: "fixed",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "black",
      //opacity: currentSlide.scrollVideo ? "1" : "0",
      pointerEvents: "none",
      zIndex: currentSlide.scrollVideo,
      width: "100vw",
      height: "100vh",
      // padding: 10,
    }}
  >
    <img
        height={height}
        preload={"true"}
        loading={"lazy"}
        src={
          `Frames/AlSina_Frame${frame}.jpg`
        }
        alt=""
      ></img>
    </div>
  );
}